/**
 * httpclient
 *
 * @file index.js
 * @author yangwei(yangwei14@baidu.com)
 */
import Client from '@baiducloud/restclient';
import requestPlugin from './plugins/request';
import responsePlugin from './plugins/response';

class HttpClient extends Client {

    /**
     * 构造方法，需要传递上下文参数获取方法
     *
     * @param {Object=} config 默认配置参数
     * @param {Object=} contextPipe 上下文参数获取方法
     */
    constructor(config) {
        super(Object.assign({
            validateStatus: status => status === 200
        }, config));
        this.req.use(requestPlugin());
        this.res.use(responsePlugin());
    }
    activeService() {
        return this.put('/internal/v1/videomeeting/user?active');
    }
    getLoginStatus() {
        return this.get('/internal/v1/videomeeting/user/detail');
    }

    // 获取会议列表
    getMeetingList(payload) {
        // return this.get('/api/v1/rooms/userviewlists/', payload);
        return this.get('/internal/v1/videomeeting/meeting/list', payload);
    }
    // 获取会议详情
    getMettingDetail(payload, options) {
        return this.get('/internal/v1/videomeeting/meeting/detail', payload, options);
    }
    // 预约会议
    scheduleMeeting(payload) {
        return this.post('/internal/v1/videomeeting/meeting', payload);
    }
    // 删除会议
    cancelMeeting(id) {
        return this.delete(`/internal/v1/videomeeting/meeting/${id}`);
    }
    // 修改会议
    modifyMeeting(id, payload) {
        return this.put(`/internal/v1/videomeeting/meeting/${id}`, payload);
    }

    // 国际化登录相关
    loginI18n(payload) {
        return this.post('/internal/v1/videomeeting/user/signin', payload);
    }

    signUpI18n(payload) {
        return this.post('/internal/v1/videomeeting/user/signup', payload);
    }

    signOutI18n(payload) {
        return this.post('/internal/v1/videomeeting/user/signout', payload);
    }

    changePasswordI18n(payload) {
        return this.post('/internal/v1/videomeeting/user/changepassword', payload);
    }

    verifyEmail(email) {
        return this.post('/internal/v1/videomeeting/user/verify', email);
    }

    verifyUrl(link) {
        return this.get(`/internal/v1/videomeeting/user/reset?auth=${link}`);
    }

    resetPassword(userid, payload) {
        return this.post(`/internal/v1/videomeeting/user/reset/${userid}-set-password/`, payload);
    }
}

export default new HttpClient();
